import React from "react";
import {Routes, Route} from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

import "./index.scss";

function App() {
    return (
        <>
        <Navbar/>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/about" element={<About title="About | John Mangahis"/>} />
            <Route path="/projects" element={<Projects title="Projects | John Mangahis"/>} />
            <Route path="/contact" element={<Contact title="Contact | John Mangahis"/>} />
        </Routes>
        </>
    )
}

export default App;